import { Icon } from '@blueprintjs/core'
import { IconName } from '@blueprintjs/icons'
import classNames from 'classnames'
import React from 'react'

import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import 'browser/components/json-elements/atoms/_checkbox-card.scss'

/**
 * Selection card UI component bound to a boolean `value`; clicking toggles it.
 * @uiComponent
 */
export interface ICheckboxCardProps extends IBaseProps {
  value?: boolean
  onChange?: (value: boolean) => void
  icon?: IconName
  title?: string
  description?: string
  isDisabled?: boolean
}

export const CheckboxCard: React.FC<ICheckboxCardProps> = (props) => {
  const { value, onChange, icon, title, description, isDisabled, style, className } = props
  const selected = !!value

  return (
    <button
      type="button"
      aria-pressed={selected}
      disabled={isDisabled}
      data-debug-id={props['data-debug-id']}
      onClick={() => onChange?.(!selected)}
      className={classNames('c-checkboxCard', {
        'c-checkboxCard--selected': selected,
      }, className)}
      style={style}
    >
      {selected && <Icon icon="tick-circle" className="c-checkboxCard-tick" />}
      {icon && <Icon icon={icon} size={22} className="c-checkboxCard-icon" />}
      {title && <span className="c-checkboxCard-title">{title}</span>}
      {description && <span className="c-checkboxCard-description">{description}</span>}
    </button>
  )
}
